import { connect } from 'react-redux'
import IndexUI from './IndexUI'
import { Dispatch } from 'redux';

import IndexState from '../../State/IndexState';
import ApplicationState from '../../../../../../../ApplicationState';
import { actionFetchFiles } from '../../Actions/ActionCretor';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { ActionType as FileActionTypes } from '../../../File/Actions/ActionTypes';
import VilgramFileDto from '../../../../../../../dto/VilagramFileDto';
import FilterDto from '../../../../../../../dto/FilterDto';
import { FilesDispatch } from './model';

const mapStateToProps = (state: ApplicationState): IState<IndexState> => {
    return {
        state: state.index
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<FilesDispatch> => ({
    dispatcher: {
        fetchFilesList: (page: number , filter : FilterDto) => { dispatch(actionFetchFiles(page, filter) as any) },
        onItemClicked: (file: VilgramFileDto) => {
            dispatch({
                type: FileActionTypes.FILE_SHOW,
                data: file
            })
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(IndexUI)